export const API_PODS = 'oneplatform/pods';
export const API_PODS_ASSIGNMENTS = 'oneplatform/pods/assignments';
